module.exports = __webpack_public_path__ + "img/video_game_console.c8ca24d8.png";